module.exports = __webpack_public_path__ + "static/media/khamsatlogo.57ed7f3a.webp";